import { Routes, Route, Navigate } from 'react-router-dom';

import './App.css';

import Navbar from './Partials/Sections/Navbar/Navbar'
import Footer from './Partials/Sections/Footer/Footer'

import Home from './Screens/Home/Home';
import Categories from './Screens/Categories/Categories';
import SubCategories from './Screens/SubCategories/SubCategories';
import AllOrganizations from './Screens/AllOrganizations/AllOrganizations';
import OrganizationDetails from './Screens/OrganizationDetails/OrganizationDetails';
import SignUp from './Screens/Auth/SignUp';
import EditProfile from './Screens/Profile/EditProfile';
import Profile from './Screens/Profile/Profile';

import Login from './Screens/Auth/AuthScreens/Login';
import VerifyEmail from './Screens/Auth/VerifyEmail';
import { useSelector } from 'react-redux';
import RecoverPassOne from './Screens/Auth/RecoverPassOne';
import RecoverPassThree from './Screens/Auth/RecoverPassThree';

function App() {

  const {consumer} = useSelector(state => state.auth)

  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/categories" element={<Categories />} />
        <Route path="/subcategory/:categoryId" element={<SubCategories />} />
        <Route path="/allOrganizations/:subCategoryId" element={<AllOrganizations />} />
        <Route path="/organization-details/:organizationId" element={<OrganizationDetails />} />

        <Route path="/profile/*" element={
          consumer
          ?
            consumer.isVerified
            ? 
              <Profile /> 
            : 
              <Navigate to='/login' />
          :
            <Navigate to='/login' />
        } />
        <Route path="/edit-profile" element={
          consumer
          ?
            consumer.isVerified
            ? 
              <EditProfile /> 
            : 
              <Navigate to='/login' />
          :
            <Navigate to='/login' />
        } />

        {/* <Route path="/login" element={!consumer.isVerified ?  <Login /> : <Navigate to='/' />} /> */}
        <Route path="/login" element={
          consumer
          ?
            consumer.isVerified
            ?
              <Navigate to='/' />
            :
              <Login />
          :
            <Login />
        } />
        <Route path="/signup" element={
          consumer
          ?
            consumer.isVerified
            ?
              <Navigate to='/' />
            :
              <SignUp />
          :
            <SignUp />
        } />
        <Route path='/verify-email/:token' element={
          consumer
          ?
            consumer.isVerified
            ?
              <Navigate to='/' />
            :
              <VerifyEmail />
          :
            <VerifyEmail />
        } />

        <Route path='/recover-pass-one' element={
          consumer
          ?
            consumer.isVerified
            ?
              <Navigate to='/' />
            :
              <RecoverPassOne />
          :
            <RecoverPassOne />
        } />
        
        <Route path='/resetForgottenPassword/:token' element={
          consumer
          ?
            consumer.isVerified
            ?
              <Navigate to='/' />
            :
              <RecoverPassThree />
          :
            <RecoverPassThree />
        } />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
